// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__1_MtV","active":"NavItem_active__2xhYM"};